"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.integrationTypes = void 0;
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Integrations_module_css_1 = __importDefault(require("./Integrations.module.css"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var IntegrationEditorModal_1 = __importDefault(require("./IntegrationEditorModal"));
var RALayout_1 = __importDefault(require("@/Layouts/RALayout"));
var react_admin_1 = require("react-admin");
var ra_data_simple_rest_1 = __importDefault(require("ra-data-simple-rest"));
var IntegrationsListView_1 = __importDefault(require("./IntegrationsListView"));
var types_1 = require("@/Types/types");
var AccessControl_1 = __importDefault(require("../common/AccessControl"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var fieldTypes;
(function (fieldTypes) {
    fieldTypes[fieldTypes["email"] = 0] = "email";
    fieldTypes[fieldTypes["password"] = 1] = "password";
    fieldTypes[fieldTypes["urls"] = 2] = "urls";
})(fieldTypes || (fieldTypes = {}));
exports.integrationTypes = [
    {
        name: "Power Bi",
        title: "Microsoft Power Bi",
        type: "webcapture",
        imageUrl: "/images/integrations/powerbi.svg",
        iconUrl: "/images/integrations/powerbi.svg",
        description: "Selecting this integration enables a seamless connection with Microsoft Power BI. Add your URLs to allow for streamlined visualization and analysis of your data",
        fields: [fieldTypes.email, fieldTypes.password, fieldTypes.urls]
    },
    {
        name: "Grafana",
        title: "Grafana",
        type: "webcapture",
        imageUrl: "/images/integrations/grafana.svg",
        iconUrl: "/images/integrations/grafana_icon.svg",
        description: "Selecting this integration enables a seamless connection with Grafana. Add your URLs to allow for streamlined visualization and analysis of your data",
        fields: [fieldTypes.email, fieldTypes.password, fieldTypes.urls]
    }
];
var Integrations = function (props) {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _a = (0, q_play_components_1.useModal)(), isShown = _a.isShown, toggle = _a.toggle;
    var _b = (0, react_1.useState)(null), currentIntegration = _b[0], setCurrentIntegration = _b[1];
    var _c = (0, react_1.useState)("new"), modalMode = _c[0], setModalMode = _c[1];
    var resourceType = types_1.ResourceType.INTEGRATION.toLowerCase() + "s";
    var openNewIntegrationModal = function () {
        setModalMode("new");
        setCurrentIntegration(null);
        toggle();
    };
    var handleRowClick = function (integration) {
        setModalMode("edit");
        setCurrentIntegration(integration);
        toggle();
    };
    return (react_1.default.createElement("div", { className: Integrations_module_css_1.default.content_container },
        react_1.default.createElement("div", { className: Integrations_module_css_1.default.buttons_container },
            react_1.default.createElement(q_play_components_1.Button, { size: "small", className: Integrations_module_css_1.default["switch-button"], title: t("Switch to app integrations"), onClick: function () { return window.location.href = "/integrations#/app-integrations"; } },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faRepeat, className: Integrations_module_css_1.default["toggle-icon"] })),
            react_1.default.createElement(AccessControl_1.default, { optionalPermissions: props.permissions.manage, resourceType: resourceType },
                react_1.default.createElement(q_play_components_1.Button, { text: t("New integration"), onClick: openNewIntegrationModal, dataCy: "createIntegrationButton" }),
                react_1.default.createElement(IntegrationEditorModal_1.default, { isShown: isShown, toggle: toggle, integration: currentIntegration, mode: modalMode, setIntegration: setCurrentIntegration, "data-cy": "integrationEditorModal" }))),
        react_1.default.createElement("div", { className: Integrations_module_css_1.default.datagrid_container },
            react_1.default.createElement(react_admin_1.Admin, { dataProvider: (0, ra_data_simple_rest_1.default)("/api/list"), disableTelemetry: true, layout: RALayout_1.default },
                react_1.default.createElement(react_admin_1.Resource, { name: "integrations", list: function () { return react_1.default.createElement(IntegrationsListView_1.default, __assign({}, props, { permissions: props.permissions, onRowClick: handleRowClick, resourceType: resourceType })); }, options: { integrationTypes: exports.integrationTypes } })))));
};
exports.default = Integrations;
